import { useEffect } from 'react';
import { useTowerLayout } from '../TowerLayout/TowerLayoutProvider';
import { LAYOUT_PAGE_DATA } from '../TowerLayout/TowerLayoutUtils';

const useUpdateTabTitle = (selectedTowerMenuItem: string) => {
    const { tabTitle, setTabTitle } = useTowerLayout();

    useEffect(() => {
        const pageData = LAYOUT_PAGE_DATA[selectedTowerMenuItem];
        setTabTitle(pageData?.tabTitle || pageData?.title || '');
    }, [selectedTowerMenuItem, setTabTitle]);

    useEffect(() => {
        const timer = setTimeout(() => {
            document.title = 'Silverfort' + (tabTitle ? ` - ${tabTitle}` : '');
        }, 400);

        return () => clearTimeout(timer);
    }, [tabTitle]);

};

export default useUpdateTabTitle;
